import styled from '@emotion/styled';
import { CSSProperties } from 'react';

import styles from '../../constants/styles';

// Local Typings
interface Props {
  alignSelf: CSSProperties['alignSelf'];
}

// Component Definition
const SecondaryElementContainer = styled.div<Props>(props => ({
  alignItems: 'center',
  alignSelf: props.alignSelf,
  backgroundColor: 'none',
  display: 'flex',
  height: '100%',
  padding: `0 ${styles.padding.xs}`,
}));

export default SecondaryElementContainer;
